export enum banktransfer_status {
    拒絕 = -2,
    取消申請 = -1,
    申請中 = 1,
    已通過 = 2,
    已匯款 = 3,
}
export enum announcement_condition {
    "'1" = "時間",
    "'2" = "觀看",
    "'3" = "點閱",
    "'1,2" = "時間、觀看",
    "'1,3" = "時間、點閱",
    "'1,2,3" = "時間、觀看、點閱",
    "'2,3" = "觀看、點閱",
}
export enum announcement_urltype {
    "'0" = "無",
    "'1" = "標題",
    "'2" = "圖",
}

export type menulist = {id:string,name:string}[];
export type page = {page:number,count:number,total_count:number};

